import type { Config, Coral, GoogleSheetsApi, Iterable, Storyblok, UserProfileService } from "./config.d";

const coral: Coral = {
  url: process.env.NEXT_PUBLIC_CORAL_URL,
  campaignIds: {
    default: process.env.NEXT_PUBLIC_CORAL_CAMPAIGN_DEFAULT_ID,
    crm10euro: process.env.NEXT_PUBLIC_CORAL_CAMPAIGN_CRM10EURO_ID,
    crm20euro: process.env.NEXT_PUBLIC_CORAL_CAMPAIGN_CRM20EURO_ID,
    crm50euro: process.env.NEXT_PUBLIC_CORAL_CAMPAIGN_CRM50EURO_ID,
  },
};

const storyblok: Storyblok = {
  accessToken: process.env.NEXT_PUBLIC_STORYBLOK_ACCESS_TOKEN,
  accountVersion: process.env.NEXT_PUBLIC_STORYBLOK_ACCOUNT_VERSION,
};

const googleSheetsApi: GoogleSheetsApi = {
  email: process.env.GOOGLE_SHEETS_API_EMAIL,
  key: process.env.GOOGLE_SHEETS_API_KEY,
};

const userProfileService: UserProfileService = {
  url: process.env.USER_PROFILE_SERVICE_URL,
  username: process.env.USER_PROFILE_SERVICE_USERNAME,
  password: process.env.USER_PROFILE_SERVICE_PASSWORD,
};

const iterable: Iterable = {
  iterableBaseUrl: process.env.ITERABLE_API_URL,
  iterableListIds: {
    blog: process.env.NEXT_PUBLIC_ITERABLE_BLOG_LIST_ID,
    partner: process.env.NEXT_PUBLIC_ITERABLE_PARTNER_LIST_ID,
  },
  smsMarketingChannelId: process.env.ITERABLE_SMS_MARKETING_CHANNEL,
};

const config: Config = {
  staticUrl: process.env.NEXT_PUBLIC_STATIC_URL,
  websiteUrl: process.env.NEXT_PUBLIC_WEBSITE_URL,
  webappUrl: process.env.NEXT_PUBLIC_WEBAPP_URL,
  ahplusUrl: process.env.NEXT_PUBLIC_AHPLUS_URL,
  funnelUrl: process.env.NEXT_PUBLIC_FUNNEL_URL,
  domainEnCa: process.env.NEXT_PUBLIC_DOMAIN_EN_CA,
  postAffiliateProUrl: process.env.NEXT_PUBLIC_POST_AFFILIATE_PRO_URL,
  gtmCode: process.env.NEXT_PUBLIC_GTM_CODE,
  gaCode: process.env.NEXT_PUBLIC_GA_CODE,
  rollbarAccessToken: process.env.NEXT_PUBLIC_ROLLBAR_ACCESS_TOKEN,
  rollbarServerAccessToken: process.env.ROLLBAR_SERVER_ACCESS_TOKEN,
  buildEnv: process.env.NEXT_PUBLIC_BUILD_ENV,
  buildVersion: process.env.NEXT_PUBLIC_BUILD_VERSION,
  trustpilotApiKey: process.env.TRUSTPILOT_API_KEY,
  legalPartnersSheetId: process.env.LEGAL_PARTNERS_SHEET_ID,
  magnitudeUrl: process.env.MAGNITUDE_URL,
  scoresApiUrl: `${process.env.SCORES_API_URL}`,
  coral,
  storyblok,
  googleSheetsApi,
  userProfileService,
  iterable,
};

export default config;
